<div
    class="need-item"
    [class.active]="highlightService.hoveredPlanningId === need.id"
    [class.current]="isCurrent"
    [class.execute-after-warning]="!isCurrent && need.data?.execute_after_date && executeAfterDateUrgency === 'warning'"
    [class.execute-after-soon]="!isCurrent && need.data?.execute_after_date && executeAfterDateUrgency === 'soon'"
    [class.execute-after-later]="!isCurrent && need.data?.execute_after_date && executeAfterDateUrgency === 'later'"
    [style.border-left-color]="
        !isCurrent && !need.data?.execute_after_date && need.status?.color ? '#' + need.status.color : null
    "
    [cdkDragData]="need"
    [cdkDragDisabled]="readOnly"
    [cdkContextMenuTriggerFor]="contextMenu"
    [cdkContextMenuTriggerData]="{ need }"
    (cdkDragEnded)="dragEnded.emit($event)"
    (cdkDragMoved)="onMoved($event)"
    (click)="onNeedClick($event)"
    (mouseenter)="hoverChange.emit(need.id)"
    (mouseleave)="hoverChange.emit(null)"
    cdkDrag>
    <div class="d-flex fw-normal">
        <div class="col">
            {{ need.projectmanager_user?.name }}
        </div>

        <div class="col text-right">
            {{ need.location | locationFormat }}
        </div>
    </div>

    <div class="d-flex">
        <span class="col"></span>
        <span class="col-projectid">
            {{
                dateInsteadOfProjectId
                    ? (need.mainPlanning?.begindate | date: 'EEE d MMM y')
                    : (need.afas_project_id ?? '---')
            }}
        </span>
        <span class="col text-right">
            @if (
                need.planning_materials | planningMaterials: materialsById | materialProperties: 'type';
                as materials
            ) {
                {{ materials }}

                @for (kind of markingKinds; track kind) {
                    <span class="badge-marking-kind">{{ MarkingKindLabels[kind] }}</span>
                }
            } @else {
                {{ entitytypes[need.mainPlanning?.entitytype_key]?.plural_name }}
            }
        </span>
    </div>

    @if (need.data?.execute_after_date) {
        <div class="execute-after-date">Uitvoeren na {{ need.data.execute_after_date | date: 'EEE d MMM yyyy' }}</div>
    }

    <div class="comment">{{ need.comment }}</div>
</div>
